import { WebhookSubscribeForm } from "./WebhookSubscribeForm";

interface Props {
  onClose: () => void;
}

export function SubscribeModal({ onClose }: Props): JSX.Element {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 no-print"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-xl border border-white/10 bg-dr-bg p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-dr-heading">
              Subscribe to updates
            </h2>
            <p className="mt-1 text-xs text-text-muted">
              Incident events delivered to your endpoint, signed with
              HMAC-SHA256 via <span className="font-mono">X-DR-Signature</span>.
            </p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="rounded p-1 text-text-muted hover:bg-white/5 hover:text-text-secondary"
          >
            ×
          </button>
        </div>
        <WebhookSubscribeForm />
      </div>
    </div>
  );
}
